import * as Type from './types'

import { executeCallback, setInMemory } from '@services/store/utils'

const initialState = {
    data: {},
    formated: {},
    loaded: null
}

export default function LandingZoneGroupsReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'landingZoneGroups'
        )
    }
    else if (action.type === Type.SET_FORMAT) {
        return executeCallback(
            setInMemory(state, action, 'formated'),
            action,
            'landingZoneGroups'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'landingZoneGroups'
        )
    }

    return state
}
